import { useMemo } from 'react'
import { useIntl } from 'react-intl'

function useProductLabels() {
  const intl = useIntl()

  return useMemo(() => {
    const leFlashHotelProductLabel = intl.formatMessage({
      id: '01VNCn7T3vmBYFBYFpb6',
      defaultMessage: 'Limited Time LUX Exclusive',
      description: 'Product label for limited time LUX exclusive flash hotel offers',
    })

    const flashHotelProductLabel = intl.formatMessage({
      id: 'C-bqH1laDvR3EYgf0KZG',
      defaultMessage: 'Limited Time Exclusive',
      description: 'Product label for limited time exclusive flash hotel offers (white label)',
    })

    const leTaoHotelProductLabel = intl.formatMessage({
      id: 'WIfEVT8Z4vqhm8FkJ-RQ',
      defaultMessage: 'LUX Premium Collection',
      description: 'Product label for LUX premium collection hotel offers',
    })

    const taoHotelProductLabel = intl.formatMessage({
      id: 'v964pgkW5qGy-t0sUUfM',
      defaultMessage: 'Premium Collection',
      description: 'Product label for premium collection hotel offers (white label)',
    })

    const lmeHotelProductLabel = intl.formatMessage({
      id: 'E1pLnozJ2Bt2N2wIuihE',
      defaultMessage: 'Last Minute Escape',
      description: 'Product type label for last minute escape hotel offers on tiles',
    })

    const leLppProductLabel = intl.formatMessage({
      id: 'qv0M-i_PYcO9rtHUpEu1',
      defaultMessage: 'LUX Partner Property',
      description: 'Product type label for LUX partner property offers on tiles',
    })

    const lppProductLabel = intl.formatMessage({
      id: 'qQ_z5ctxvaPilv_3pAhY',
      defaultMessage: 'Partner Property',
      description: 'Product label for partner property offers (white label)',
    })

    const luxBundleLabel = intl.formatMessage({
      id: 'megTQiPFu60aLpIUuwzs',
      defaultMessage: 'Bundle & Save',
      description: 'Product label for bundle and save offers on the offer page',
    })

    const lePartner = intl.formatMessage({
      id: 's5YLS4Iw1KZa7W1wuSD4',
      defaultMessage: 'LUX Trusted Partner',
      description: 'Product label for LUX trusted partner on the offer page',
    })

    const leExclusive = intl.formatMessage({
      id: 'W88BRGxYElcaWNfmislw',
      defaultMessage: 'LUX Exclusive',
      description: 'Product label for LUX exclusive on the offer listing or detail page',
    })

    return {
      leFlashHotelProductLabel,
      flashHotelProductLabel,
      leTaoHotelProductLabel,
      taoHotelProductLabel,
      lmeHotelProductLabel,
      leLppProductLabel,
      lppProductLabel,
      luxBundleLabel,
      lePartner,
      leExclusive,
    }
  }, [intl])
}

export default useProductLabels
